import React, { lazy } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const MARQUEE_SET = [{
  slug: 'slack',
  name: 'Slack'
}, {
  slug: 'gmail',
  name: 'Gmail'
}, {
  slug: 'googledrive',
  name: 'Google Drive'
}, {
  slug: 'googlecalendar',
  name: 'Google Calendar'
}, {
  slug: 'hubspot',
  name: 'HubSpot'
}, {
  slug: 'salesforce',
  name: 'Salesforce'
}, {
  slug: 'asana',
  name: 'Asana'
}, {
  slug: 'airtable',
  name: 'Airtable'
}, {
  slug: 'notion',
  name: 'Notion',
  light: true
}, {
  slug: 'linear',
  name: 'Linear'
}, {
  slug: 'calendly',
  name: 'Calendly'
}, {
  slug: 'zoom',
  name: 'Zoom'
}, {
  slug: 'intercom',
  name: 'Intercom'
}, {
  slug: 'dropbox',
  name: 'Dropbox'
}, {
  slug: 'figma',
  name: 'Figma'
}, {
  slug: 'stripe',
  name: 'Stripe'
}];
function LogoTile({
  logo
}: {
  logo: {
    slug: string;
    name: string;
    light?: boolean;
  };
}) {
  return <div className="shrink-0 flex items-center justify-center w-16 h-16 md:w-[100px] md:h-[100px] rounded-xl md:rounded-2xl bg-[#1A1410] border border-white/[0.07] shadow-lg shadow-black/30" title={logo.name} data-id="element-5445" data-mp="177vs26dmyyfq">
      <img src={`https://cdn.simpleicons.org/${logo.slug}${logo.light ? '/e8e6e3' : ''}`} alt={logo.name} className="w-7 h-7 md:w-11 md:h-11 object-contain" loading="lazy" onError={e => {
      const img = e.currentTarget as HTMLImageElement;
      if (!img.dataset.fallback) {
        img.dataset.fallback = '1';
        img.src = `https://cdn.jsdelivr.net/gh/walkxcode/dashboard-icons/svg/${logo.slug}.svg`;
      } else {
        img.style.visibility = 'hidden';
      }
    }} data-id="element-5446" data-mp="1h6v3fwpsd86f" />
    </div>;
}
function LogoMarquee({
  reducedMotion
}: {
  reducedMotion: boolean;
}) {
  return <div className="relative w-full overflow-hidden py-10" style={{
    WebkitMaskImage: 'linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)',
    maskImage: 'linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)'
  }} data-id="element-5447" data-mp="28xr7c7tvc2hk">
      <motion.div className="flex gap-3 md:gap-5 w-max" animate={reducedMotion ? undefined : {
      x: ['-50%', '0%']
    }} transition={reducedMotion ? undefined : {
      duration: 40,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-5448" data-mp="2bx9fu78xbb1i">
        {[...MARQUEE_SET, ...MARQUEE_SET].map((logo, i) => <LogoTile key={`${logo.slug}-${i}`} logo={logo} data-id="element-5449" data-mp="2qpl2l60qrv30" data-mpi={i} />)}
      </motion.div>
    </div>;
}
export function StaticConnectionsHero() {
  const reducedMotion = useReducedMotion();
  const navigate = useNavigate();
  return <section className="relative w-full bg-[#2B211A] pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden" data-id="element-5450" data-mp="2zqrl1kmybfyw">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 relative z-10 flex flex-col items-center text-center" data-id="element-5451" data-mp="34m6yibh1r9us">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-title font-medium text-white tracking-tight leading-[1.1] mb-6 max-w-4xl" data-id="element-5452" data-mp="1aaa0u0s0h7ra">
          Giga plugs into your world
        </h1>
        <p className="text-lg md:text-xl text-white/70 max-w-2xl mb-12" data-id="element-5453" data-mp="1faxzn8mhesw2">
          Connect everything you already use. Giga ties your whole stack
          together so context flows freely—no more copying, pasting, or
          switching tabs.
        </p>

        <div className="w-full max-w-5xl mx-auto mb-12" data-id="element-5454" data-mp="3jrukz0kxnk3o">
          <LogoMarquee reducedMotion={!!reducedMotion} data-id="element-5455" data-mp="3es884s90o5ve" />
        </div>

        <button onClick={() => navigate('/integrations')} className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#EA580C] px-8 py-4 text-base font-semibold text-white shadow-lg shadow-[#EA580C]/20 transition-all duration-300 hover:bg-[#d24e09] hover:scale-105" data-id="element-5456" data-mp="3epvhzrt3up79">
          See all integrations
          <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-5457" data-mp="1d23zqfzpjap" />
        </button>
      </div>
    </section>;
}